module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/78376db7fd249ff51136ac8f1e948827.png";